export default function Badge({ status }) {
  if (!status) return null;
  const s = status.toLowerCase();
  if (s === 'published') return <span className="b b-g"><span className="b-dot" />Published</span>;
  if (s === 'draft')     return <span className="b b-o"><span className="b-dot" />Draft</span>;
  if (s === 'archived')  return <span className="b b-gr"><span className="b-dot" />Archived</span>;
  if (s === 'active')    return <span className="b b-g"><span className="b-dot" />Active</span>;
  return <span className="b b-gr"><span className="b-dot" />{status}</span>;
}
